(function (){
  setupToggleDescription('descriptionBox', 'toggleDescription');
  national()
})();
/**
 * 展开收起功能函数
 */
function setupToggleDescription(containerId, buttonId, collapsedClass = 'collapsed') {
  const box = document.getElementById(containerId);
  const button = document.getElementById(buttonId);
  if (!box || !button) return;
  button.addEventListener('click', function () {
    box.classList.toggle(collapsedClass);
    button.textContent = box.classList.contains(collapsedClass) ? 'show more+' : 'show less-';
  });
}
/**
 * 国旗功能函数
 */
function national(){
  var contry_USAandGE = document.querySelector('.contry_USAandGE');
  var contry_box = document.querySelector('.contry_box');
  var contry_USAandGEList = document.querySelector(
    '.contry_USAandGEList'
  );
  contry_USAandGE.addEventListener('mouseenter', function () {
    contry_USAandGEList.style.display = 'block';
  });
  contry_box.addEventListener('mouseleave', function () {
    contry_USAandGEList.style.display = 'none';
  });
}



